import colors from '../style/colors';

export const tabStyles = {
  fontFamily: 'Poppins',
  textTransform: 'inherit',
  fontSize: 'inherit',
  minHeight: '44px',
  color: `${colors.gray['400']} !important`,
};
